export default function isValidDateRangeOption(dateRangeOption) {
    return !!(dateRangeOption
        && dateRangeOption.name
        && Array.isArray(dateRangeOption.value)
        && dateRangeOption.value.length === 2);
}
